import React from 'react';
/* CSS */
import './style.css'

export const ScrollArrows = ({ isSimulator = false }) => {
  const scrollUp = function() {
    window.$("html, body").animate({ scrollTop: 0 },"slow");
  }

  const scrollDown = function() {
    window.$("html, body").animate({ scrollTop: window.$(document).height() },"slow");
  }

  return (
    <>
      <button 
        type="button"
        className={`sticky-icon sticky-up ${ isSimulator ? "sticky-icon-white" : ""}`}
        onClick={scrollUp}
        aria-label="Torna su"
      >
      </button>
      <button 
        type="button"
        className={`sticky-icon sticky-down ${ isSimulator ? "sticky-icon-white" : ""}`}
        onClick={scrollDown}
        aria-label="Torna giù"
      >
      </button>
    </>
  );
}
